import { render, staticRenderFns } from "./adminDetail.vue?vue&type=template&id=738ee491&scoped=true&"
import script from "./adminDetail.vue?vue&type=script&lang=js&"
export * from "./adminDetail.vue?vue&type=script&lang=js&"
import style0 from "./adminDetail.vue?vue&type=style&index=0&id=738ee491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ee491",
  null
  
)

export default component.exports